import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { Card } from '@entities/home/components/card';

import { config } from '@/config.ts';

import * as Styled from './cards.styled.ts';
import { getCardsForBrand } from './get-brand-cards.ts';

const Cards = () => {
	const { t } = useTranslation('main');
	const brand = config.BRAND;
	const cards = getCardsForBrand(brand);

	return (
		<Styled.CardWrapper>
			{cards.map(item => (
				<Card key={item.id} title={item.text_key ? t(item.text_key) : item.text} link={item.link} image={item.img} />
			))}
		</Styled.CardWrapper>
	);
};

export default Cards;
